export default "__VITE_ASSET__DvSOOtqD__"